import { Directive, OnChanges, Input, HostBinding, ElementRef } from '@angular/core';

@Directive({
	selector: '[smoothHeight]',
	host: {'[style.display]': '"block"', '[style.flex]': '"none"'}
})
export class SmoothHeightDirective implements OnChanges {

	private overflowTiming;

	private pulse: boolean = true;
	private startHeight: number = 0;
	
	@Input() smoothHeight: any;

	constructor(private window: Window,
				private element: ElementRef) {}

	@HostBinding('@grow') get grow() {
		return {value: this.pulse, params: {startHeight: this.startHeight}};
	}

	ngOnChanges() {

		this.element.nativeElement.style.overflow = 'hidden';

		const currentStyle = this.element.nativeElement.currentStyle || 
							 this.window.getComputedStyle(this.element.nativeElement);

		this.startHeight = this.element.nativeElement.clientHeight 
							- parseInt(currentStyle.paddingTop)
							- parseInt(currentStyle.paddingBottom);

		this.pulse = !this.pulse;

		if(this.overflowTiming)
			clearTimeout(this.overflowTiming);

		this.overflowTiming = setTimeout(() => this.element.nativeElement.style.removeProperty('overflow'), 275);
	}
}